/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetConvenienceSummaryQueryResponse,
  GetConvenienceSummaryQueryParams,
} from '../types/GetConvenienceSummary'

function getGetConvenienceSummaryUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/places/convenience/summary/` as const,
  }
  return res
}

/**
 * @summary Convenience chains summary counts
 * {@link /api/v1/places/convenience/summary/}
 */
export async function getConvenienceSummary(
  params?: GetConvenienceSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetConvenienceSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetConvenienceSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
